import React, { useRef, useEffect } from "react"
import { useInfiniteHits } from "react-instantsearch"
import loadingIndicator from "../../images/loading-indicator.svg"
import SearchHit from "./SearchHit"

const connectInfiniteHits = Component => {
  const InfiniteHits = props => {
    const data = useInfiniteHits()

    return <Component {...props} {...data} />
  }

  return InfiniteHits
}

export const InfiniteHits = ({ hits, isLastPage, showMore, locale }) => {
  const sentinelRef = useRef(null)

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (sentinelRef.current !== null) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry?.isIntersecting && !isLastPage) {
              showMore()
            }
          })
        })

        observer.observe(sentinelRef.current)

        return () => {
          observer.disconnect()
        }
      }
    }
  }, [isLastPage, showMore])

  return (
    <div className={`nav-search__infinite-hits`}>
      <ul className="nav-search__infinite-hits--list">
        {hits?.map(hit => (
          <li key={hit.objectID} className="nav-search__infinite-hits--item">
            <SearchHit hit={hit} locale={locale} />
          </li>
        ))}
        {!isLastPage && (
          <img
            className="nav-search__infinite-hits--loading-indicator"
            src={loadingIndicator}
            alt="Rotating loading indicator"
          />
        )}
        <li className="nav-search__infinite-hits--sentinel" ref={sentinelRef} />
      </ul>
    </div>
  )
}

const CustomInfiniteHits = connectInfiniteHits(InfiniteHits)

export default CustomInfiniteHits
